import React from 'react'
import { navigate } from 'gatsby'

import { withFirebase } from '../Firebase'
import * as ROUTES from '../../../constants/routes'

const SignOutButton = ({ firebase }) => {
    return (
        <button
            type="button"
            onClick={
                firebase
                    ? firebase.doSignOut && navigate(ROUTES.HOME)
                    : () => {}
            }
        >
            Sign Out
        </button>
    )
}

export default withFirebase(SignOutButton)
